export default "__VITE_ASSET__DzE1CCSv__"